import { createFileRoute, Link } from "@tanstack/react-router";

const FREQ_LABEL: Record<string, string> = {
  daily: "hver dag",
  weekly: "hver søndag",
  monthly: "den 1. i hver måned",
};

export const Route = createFileRoute("/nyhedsbrev/frekvens-skiftet")({
  head: () => ({
    meta: [
      { title: "Frekvens ændret · Flâneriet" },
      { name: "robots", content: "noindex" },
    ],
  }),
  validateSearch: (search: Record<string, unknown>) => ({
    status: (search.status as string) ?? "ok",
    to: (search.to as string) ?? "",
  }),
  component: FrekvensSkiftetPage,
});

function FrekvensSkiftetPage() {
  const { status, to } = Route.useSearch();
  const ok = status === "ok" && (to === "daily" || to === "weekly" || to === "monthly");
  const label = ok ? FREQ_LABEL[to] : null;

  return (
    <main className="max-w-[640px] mx-auto px-6 py-20">
      {ok ? (
        <>
          <p className="eyebrow mb-3" style={{ color: "var(--accent, #7a3b2e)" }}>Brevet</p>
          <h1 className="font-serif text-[28px] md:text-[34px] leading-[1.1] mb-5 text-ink">
            Sådan. Du får nu Flâneriet {label}.
          </h1>
          <p className="font-serif font-light text-[16px] leading-[1.65] text-ink-soft mb-8">
            Ingen bekræftelses-mail nødvendig. Skiftet træder i kraft med det samme, og
            du kan altid ændre det igen fra bunden af næste brev.
          </p>
        </>
      ) : (
        <>
          <p className="eyebrow mb-3" style={{ color: "var(--accent, #7a3b2e)" }}>Brevet</p>
          <h1 className="font-serif text-[28px] md:text-[34px] leading-[1.1] mb-5 text-ink">
            Linket kunne ikke bruges
          </h1>
          <p className="font-serif font-light text-[16px] leading-[1.65] text-ink-soft mb-8">
            Linket er enten udløbet eller allerede brugt. Åbn det seneste brev i din indbakke og
            prøv et af de friske frekvens-links i bunden.
          </p>
        </>
      )}
      <Link
        to="/"
        className="font-serif italic text-[15px]"
        style={{ color: "var(--accent, #7a3b2e)" }}
      >
        ← Tilbage til flaneriet.online
      </Link>
    </main>
  );
}
